import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from 'recharts';
import { Box, lighten, Typography, useTheme } from '@mui/material';
import { BusinessLifecycleTrendItem } from '@/apis/agency/businessInsights/types';

interface Props {
  data: BusinessLifecycleTrendItem[];
}

export default function BusinessLifecycleChart({ data }: Props) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  const STATUS_COLORS = {
    active: primaryColor,
    archived: lighten(primaryColor, 0.82)
  };

  return (
    <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mt={3}>
      <Box display='flex' justifyContent='space-between' alignItems='flex-start' flexWrap='wrap' gap={1}>
        <Typography variant='h6' fontWeight={500}>
          Last 12 Month Business Lifecycle Trend
        </Typography>
      </Box>

      <ResponsiveContainer width='100%' height={320}>
        <BarChart data={data} barGap={4} margin={{ top: 40, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' vertical={false} />
          <XAxis dataKey='month' />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend verticalAlign='top' align='right' iconType='circle' wrapperStyle={{ top: -10, right: 0 }} />
          <Bar dataKey='active' name='Active' fill={STATUS_COLORS.active} radius={[4, 4, 0, 0]} />
          <Bar dataKey='archived' name='Archived' fill={STATUS_COLORS.archived} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
